@import "/src/styles/mixins.sass"

@mixin sliderThumb
    @include reset
    width: 1rem
    height: 1rem
    border-radius: 100%
    background-color: var(--color-black-primary)

@mixin sliderThumbFocused
    background-color: var(--color-white-primary)
    box-sizing: border-box
    border: 0.2rem solid var(--color-blue-focus)

@mixin sliderThumbDisabled
    background-color: var(--color-grey-primary)

@mixin sliderTrack
    @include reset
    height: 0.25rem
    background-color: var(--color-black-primary-disabled)
    border-radius: 1rem

@mixin sliderTrackDisabled
    background-color: var(--color-grey-primary)

.movableLabel
    label
        position: relative
        z-index: 10
        top: 2rem
        transition: top 0.2s ease-out
        pointer-events: none

    &.moved, &:focus-within
        label
            top: 0

.container
    position: relative
    width: 100%

    svg
        pointer-events: none
        position: absolute
        right: 0.5rem
        height: 100%
        color: var(--color-grey-dark)

.input
    &.hasIcon
        padding-right: 2.25rem !important

    &:not([type="range"])
        @include reset
        @include input
        cursor: text
        padding: 0.75rem
        background-color: var(--color-grey-primary)
        box-shadow: inset 0 -0.2rem 0 0 var(--color-black-primary)
        border-radius: 0.75rem
        transition: border-radius 0.2s ease

        &:invalid
            box-shadow: inset 0 -0.2rem 0 0 var(--color-red-dangerous)

            &:disabled
                box-shadow: inset 0 -0.2rem 0 0 var(--color-red-dangerous-disabled)

        &:focus
            border-radius: 0.2rem
            outline: none
            box-shadow: inset 0 -0.25rem 0 0 var(--color-blue-focus)

        &:disabled
            color: var(--color-black-primary-disabled)
            background-color: var(--color-grey-light)
            border-radius: 0
            box-shadow: inset 0 -0.2rem 0 0 var(--color-black-primary-disabled) !important
            cursor: not-allowed

    &[type="date"]
        min-height: 2.6rem

    &[type="button"]
        cursor: pointer
        text-align: left

    &[type="range"]
        @include reset
        cursor: pointer
        height: 1.5rem

        &::-ms-thumb
            @include sliderThumb
        &::-moz-range-thumb
            @include sliderThumb
        &::-webkit-slider-thumb
            position: relative
            top: -0.4rem
            @include sliderThumb

        &::-webkit-slider-runnable-track
            @include sliderTrack
        &::-moz-range-track
            @include sliderTrack
        &::-ms-track
            @include sliderTrack

        &:disabled
            cursor: not-allowed

            &::-ms-thumb
                @include sliderThumbDisabled
            &::-moz-range-thumb
                @include sliderThumbDisabled
            &::-webkit-slider-thumb
                @include sliderThumbDisabled

            &::-webkit-slider-runnable-track
                @include sliderTrackDisabled
            &::-moz-range-track
                @include sliderTrackDisabled
            &::-ms-track
                @include sliderTrackDisabled

        &:focus-visible
            outline: none

            &::-ms-thumb
                @include sliderThumbFocused
            &::-moz-range-thumb
                @include sliderThumbFocused
            &::-webkit-slider-thumb
                @include sliderThumbFocused
